/**
 * UC Auth SDK 初始化配置
 * 托管页模式接入（使用 AuthProvider）
 */
import {
    ChannelType,
    SceneType,
    type UCAuthConfig
} from '@eworld/uc-auth/packages/react'
import { checkTicket } from '@/api/user'
import { getUcCode } from '../index'

// 从环境变量读取配置
const UC_CODE = getUcCode()

// 获取 URL 参数
const getUrlParam = (key: string): string | null => {
    const urlParams = new URLSearchParams(window.location.search)
    return urlParams.get(key)
}

// 获取 hash 查询参数（支持 hash 路由模式，如 #/path?key=value）
const getHashParam = (key: string): string | null => {
    const hashIndex = window.location.hash.indexOf('?')
    if (hashIndex === -1) return null
    const hashParams = new URLSearchParams(window.location.hash.substring(hashIndex + 1))
    return hashParams.get(key)
}

// 获取 SDK 参数（支持 URL 参数和路径模式）
// URL 参数模式：?sdk=ewan
// 路径模式：/sdk/ewan
const getSdkParam = (): string | null => {
    // 优先从 URL 参数获取
    const sdkFromQuery = getUrlParam('sdk')
    if (sdkFromQuery) {
        return sdkFromQuery
    }

    // 从路径中获取（匹配 /sdk/xxx 模式）
    const pathMatch = window.location.pathname.match(/\/sdk\/([^\/]+)/)
    if (pathMatch && pathMatch[1]) {
        return pathMatch[1]
    }

    return null
}

const sdkParam = getSdkParam();
const channelType = !sdkParam || sdkParam === 'ewan' ? ChannelType.YISHIJIE : ChannelType.MIAOYOU;
// 创建认证配置
export const authConfig: UCAuthConfig = {
    // 用户中心编码
    ucCode: UC_CODE,
    // 环境配置
    environment: process.env.REACT_APP_REAL_ENV,
    // 登录模式：托管页模式
    mode: 'modal',
    // 渠道类型：益世界/妙游
    channelType: channelType,
    // 场景类型：客服
    sceneType: SceneType.CS,
    // 游戏 ucCode（可选）
    gameUcCode: getUrlParam('gameUcCode') || undefined,
    // 游戏用户信息（可选）
    gameUserInfo: getUrlParam('userInfo') || getUrlParam('userinfo') || getHashParam('userInfo') || getHashParam('userinfo') || undefined,
    // 调试模式
    debug: process.env.REACT_APP_REAL_ENV !== 'production',
    // 业务系统登录回调：使用 ticket 换取业务 token
    loginByTicket: async (ticket: string) => {
        const result: any = await checkTicket({ ticket, ucCode: UC_CODE })
        if (result?.code === 0 && result?.data) {
            localStorage.setItem('token', result.data)
            return result.data
        }
        throw new Error(result?.msg || '登录失败')
    }
}
